export default [
  {id: 'basic', name: 'FAUTEUIL', value: 0},
  {id: 'bunk', name: 'COUCHETTE', value: 1},
  {id: 'cabin2i', name: 'CABINE INTÉRIEUR 2 LITS', value: 2},
  {id: 'cabin2e', name: 'CABINE EXTÉRIEURE 2 LITS', value: 3},
  {id: 'cabin4i', name: 'CABINE INTÉRIEUR 4 LITS', value: 4},
  {id: 'cabin4e', name: 'CABINE EXTÉRIEURE 4 LITS', value: 5}
]



// WEBPACK FOOTER //
// ./src/shared/routers/languages/fr/arrays/locations.js